var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSomeLinkedinCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35ZM8.70635 25.9H12.3442V14.2206H8.70635V25.9ZM8.4 10.5061C8.4 11.6549 9.35733 12.6123 10.5061 12.6123C11.6932 12.6123 12.6123 11.6932 12.6123 10.5061C12.6123 9.35733 11.6549 8.4 10.5061 8.4C9.35733 8.4 8.4 9.35733 8.4 10.5061ZM22.3004 25.9H25.9383V19.505C25.9383 16.365 25.249 13.9525 21.5729 13.9525C19.8114 13.9525 18.6243 14.9098 18.1265 15.8289H18.0882V14.2206H14.6035V25.9H18.2414V20.1177C18.2414 18.6243 18.5477 17.1309 20.4241 17.1309C22.2621 17.1309 22.3004 18.8923 22.3004 20.2326V25.9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomeLinkedinCircle);
export default __webpack_public_path__ + "static/media/some-linkedin-circle.69cd7e1e8816968b241c4e877945c456.svg";
export { ForwardRef as ReactComponent };